__turbopack_context__.v({
  "BentoCardSizeCss": "StyleConstants-module__9NPYwq__BentoCardSizeCss",
  "BentoHeading": "StyleConstants-module__9NPYwq__BentoHeading",
  "BentoPara": "StyleConstants-module__9NPYwq__BentoPara",
});
